module.exports = __webpack_public_path__ + "static/gallery-3-8e469b125431a0e6ff676ed53c5860e8.jpg";